/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Signup_Free_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "The Free plan could not be started: {message}" |
*
* @param {Signup_Free_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_free_failed_toast = /** @type {((inputs: Signup_Free_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Free_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de démarrer l'offre Gratuite : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Free-Tarif konnte nicht gestartet werden: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile avviare il piano Gratuito: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось подключить тариф Free: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo iniciar el plan Gratis: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法开通免费套餐：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Free プランを開始できませんでした：${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Free प्लान शुरू नहीं हो सका: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível iniciar o plano Gratuito: ${i?.message}`)
	return /** @type {LocalizedString} */ (`The Free plan could not be started: ${i?.message}`)
});